export default __webpack_public_path__ + "static/media/4.8df45b98.png";